export default __webpack_public_path__ + "static/dillon-28a760827aba65c244fd67386c451f34.png";